// LoginPage.js
import React, { use, useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import  "../index.css";
import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config";
import MHeader from "./header";
import Mfooter from "./footer";

//const apiServerAddress = "https://api3e.soluzioni-it.eu/";
//const apiServerAddress = "http://localhost:3001/";
const customStyles = {
  control: (base) => ({
    ...base,
    width: "80%",  // Cambia larghezza
    minHeight: "40px", // Altezza minima
    fontSize: "16px",  // Dimensione testo
  }),
};
let bearer;
let loginSrv = ""




function NewUser({ setUser, setPass,setBea }) {
    const [nome, setNome] = useState("");
    const [cognome, setCognome] = useState("");
    const [nusername, setnUsername] = useState("");
    const [npassword, setnPassword] = useState("");
    const [profilo1, setProfilo] = useState("");

    const [users, setUsers] = useState(null);
    const optionProfile = [{label:"User", value:"User"},{label:"Admin", value:"Admin"}];
    const navigate = useNavigate();
    const  OptionsProf = [
        {label:"Admin",  value:"Admin"},
        {label:"User",  value:"User"}
    ];


     useEffect(() => {
        fetch(config.apiUrl+"/getusers" ,{
            method: "POST",
            headers: {
                "Authorization": "Bearer "+localStorage.getItem("token")
              }
        })
        .then((res) => res.json())
        .then((usersData) => setUsers(usersData))
        .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
    },[]);  
    
  const handleSave = async () => {
    try{
      const formData = new FormData();
      formData.append("username", nusername);
      formData.append("password", npassword);
      formData.append("cognome", cognome);
      formData.append("nome", nome);
      formData.append("profilo1", profilo1.value);
     
      const response = await fetch(config.apiUrl+"/newuser", {
        method: "POST",
        headers: {
                "Authorization": "Bearer "+localStorage.getItem("token")
              },
        body: formData,
      });
      if (!response.ok) throw new Error("Errore nella richiesta al server");
      //else:
      
      //
      const data = await response.json();
      navigate("/");
      
    } catch (err) {
      //do something
    }

    
    
  };

  return (
    <div className="App">
        <h2  className="App-header">{config.appName}</h2>
      <MHeader/>
      
      <p></p>
      <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
      <form>
      Cognome:<p></p>
      <input
        type="text"
        placeholder="Inserisci cognome"
        value={cognome}
        onChange={(e) => setCognome(e.target.value)}
      />
    <p></p>
      Nome:<p></p>
      <input
        type="text"
        placeholder="Inserisci Nome"
        value={nome}
        onChange={(e) => setNome(e.target.value)}
      />
      <p></p>
      Username:<p></p>
      <input
        type="text"
        placeholder="Inserisci username"
        value={nusername}
        onChange={(e) => setnUsername(e.target.value)}
      />
      <p>
      </p>
      Password:<p></p>
      <input
        type="password"
        placeholder="Inserisci password"
        value={npassword}
        onChange={(p) => setnPassword(p.target.value)}
        
      />
      <p></p>
      Profilo:<p></p>
          <Select
            options={OptionsProf}
            value={profilo1}
            onChange={setProfilo}
            placeholder="Seleziona un profilo..."
            isClearable
          />
           
          <p></p>
        {profilo1 && nusername  && npassword && (
          <button onClick={handleSave}><SaveIcon className="mr-2" /><br/>Salva</button>
        )}
        <p>


        </p>
        {users && users.length > 0 && (
        <div>
          <h3>Utenti</h3>
          <table border="1" style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                {Object.keys(users[0]).map((key) => (
                  <th key={key} style={{ padding: "8px", textAlign: "left", backgroundColor: "#f2f2f2" }}>
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {
              users.map((item, index) => (
                <tr key={index}>
                  {Object.values(item).map((value, i) => (
                    <td key={i} style={{ padding: "8px" }}>{String(value)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </form>
    </div>
    <Mfooter/>
    </div>
  );
}

export default NewUser;